import { useState, useEffect } from 'react';

const IS_SERVER = typeof window === 'undefined';

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState<boolean>(() => {
        if (IS_SERVER) {
            return false;
        }
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        if (IS_SERVER) {
            return;
        }

        const mediaQuery = window.matchMedia(query);

        const handleChange = () => {
            setMatches(mediaQuery.matches);
        };

        // Set initial value
        setMatches(mediaQuery.matches);

        // Listen for changes
        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [query]);

    return matches;
}
